module.exports = __webpack_public_path__ + "static/malcolm-gladwell-029a112e0f917adf9d514afc692317b6.jpg";